import React from 'react';
import styles from './AboutSection.module.css';

const AboutSection = () => {

    const aboutImg = '/images/31-DSC09442.jpg'

    return (
        <section className={styles.section}>
            <div className={styles.container}>

                {/* ── Left Column ── */}
                <div className={styles.leftCol}>

                    <p className={styles.label}>Our Story</p>

                    <h2 className={styles.heading}>
                        Some stories start <em>in a brewery.</em>{' '}
                        Ours started at the door.
                    </h2>

                    <div className={styles.body}>
                        <p className={styles.paragraph}>
                            Berli Brewing Co. was born from a simple belief — that a guest
                            should feel seen, welcomed, like they are the best part of someone's
                            day. Inspired by our dog Berli, and rooted in the craft traditions
                            of Yorkshire, we brew small batches with quiet attention and
                            hyperlocal ingredients sourced from farmers in Pune and Maharashtra.
                        </p>
                        <p className={styles.paragraph}>
                            Twelve craft beers. One warm, unpretentious space in Kharadi.
                            And yes — your dog is welcome here.
                        </p>
                    </div>

                </div>

                {/* ── Right Column ── */}
                <div className={styles.rightCol}>
                    <div className={styles.imageFrame}>
                        <img
                            src={aboutImg}
                            alt="Berli Brewing Co. experience"
                            className={styles.image}
                        />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default AboutSection;